import { NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Tent } from "lucide-react";
import DigestToggle from "@/components/DigestToggle";
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

export function Brand({ compact = false }) {
  return (
    <div className="flex items-center gap-2 md:gap-3">
      <div className={`${compact ? "w-9 h-9" : "w-10 h-10"} rounded-lg bg-primary text-primary-foreground flex items-center justify-center`}>
        <Tent className={compact ? "w-4 h-4" : "w-5 h-5"} />
      </div>
      <div>
        <div className={`font-bold ${compact ? "text-sm" : "text-base"} leading-tight`} style={{ fontFamily: "Outfit" }}>Lough Scouts</div>
        <div className={`text-muted-foreground ${compact ? "text-[10px] uppercase tracking-wider" : "text-xs"}`}>{compact ? "5th Cork" : "5th Cork Group"}</div>
      </div>
    </div>
  );
}

export function Sidebar({ items, pending, user, onLogout }) {
  return (
    <aside className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 border-r border-border bg-card">
      <div className="px-6 py-6 border-b border-border"><Brand /></div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium min-h-[44px] transition-colors ${
                isActive ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-secondary hover:text-primary"}`}>
            <Icon className="w-4 h-4" />
            {label}
            {to === "/leaders" && pending > 0 && (
              <span data-testid="nav-leaders-badge" className="ml-auto text-xs font-bold bg-destructive text-destructive-foreground rounded-full px-2 py-0.5">{pending}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-border">
        <div className="text-xs text-muted-foreground mb-2">Signed in as</div>
        <div className="text-sm font-semibold truncate" data-testid="user-name">{user?.name}</div>
        <div className="text-xs text-muted-foreground truncate mb-3">{user?.email}</div>
        <DigestToggle />
        <ChangePasswordDialog />
        <Button data-testid="logout-btn" variant="outline" size="sm" className="w-full" onClick={onLogout}>
          <LogOut className="w-4 h-4 mr-2" /> Sign out
        </Button>
      </div>
    </aside>
  );
}

export function MobileNav({ items, onLogout }) {
  return (
    <>
      <header className="md:hidden sticky top-0 z-30 bg-card border-b border-border px-4 py-3 flex items-center justify-between">
        <Brand compact />
        <Button data-testid="logout-btn-mobile" variant="ghost" size="sm" onClick={onLogout}><LogOut className="w-4 h-4" /></Button>
      </header>
      <nav className={`md:hidden fixed bottom-0 inset-x-0 z-30 bg-card border-t border-border grid ${items.length > 7 ? "grid-cols-8" : "grid-cols-7"}`}>
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={`${testid}-mobile`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-2 text-[10px] min-h-[56px] ${isActive ? "text-primary font-semibold" : "text-muted-foreground"}`}>
            <Icon className="w-5 h-5" />
            {label.split(" ")[0]}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
